import DataService from '@/service/DataService'
import Benutzer from './Benutzer'

const state = {
  status: {},
  adminRegisterBenutzer: null,
  adminRegisterBenutzerGeraet: null,
  adminRegisterBenutzerKontakte: []
}

const getters = {
  adminStatus: (state) => state.status,
  adminRegisterBenutzer: (state) => state.adminRegisterBenutzer,
  adminRegisterBenutzerGeraet: (state) => state.adminRegisterBenutzerGeraet,
  adminRegisterBenutzerKontakte: (state) => state.adminRegisterBenutzerKontakte
};

const actions = {
  resetAdminBenutzerData({ commit }) {
    commit("RESETADMINBENUTZERDATA")
  },

  // GET
  adminGetBenutzerKontakte({ commit }, userId) {
    commit('ADMINGETBENUTZERKONTAKTEREQUEST')

    return DataService.adminGetUserKontakte(userId)
      .then(res => {
        commit('ADMINGETBENUTZERKONTAKTESUCCESS', {data: res.data, userId})
      })
      .catch(err => {
        commit('ADMINGETBENUTZERKONTAKTEFAILURE', err)
      })
  },
  adminGetBenuzterGeraete( {commit}, userId) {
    commit('ADMINGETBENUTZERGERAETEREQUEST')

    return DataService.adminGetUserGeraete(userId)
      .then(res => {
        commit('ADMINGETBENUTZERGERAETESUCCESS', {data: res.data, userId})
      })
      .catch(err => {
        commit('ADMINGETBENUTZERGERAETEFAILURE', err)
      })
  },


  // POST
  adminBenutzerAnlegen({ commit }, benutzer) {
    commit('ADMINCREATEBENUTZERREQUEST')

    return DataService.adminCreateUser(benutzer)
      .then(res => {
        commit('ADMINCREATEBENUTZERSUCCESS', res.data)
      })
      .catch(err => {
        commit('ADMINCREATEBENUTZERFAILURE', err)
      })
  },
  adminBenutzerKontaktAnlegen({ commit }, data) {
    commit('ADMINCREATEBENUTZERKONTAKTREQUEST')

    data.kontakt.favorit = data.kontakt.favorit == "1" ? 1 : 0;

    return DataService.adminCreateUserKontakt(data.userId, data.kontakt)
      .then(res => {
        commit('ADMINCREATEBENUTZERKONTAKTSUCCESS', {userId: data.userId, kontakt: res.data})
      })
      .catch(err => {
        commit('ADMINCREATEBENUTZERKONTAKTFAILURE', err)
      })
  },
  adminRegisterBenutzerNeuerKontakt({ commit }, data) {
    commit('ADMINCREATEREGISTERBENUTZERKONTAKTREQUEST')

    return DataService.adminCreateUserKontakt(data.userId, data.kontakt)
      .then(res => {
        commit('ADMINCREATEREGISTERBENUTZERKONTAKTSUCCESS', {userId: data.userId, kontakt: res.data})
      })
      .catch(err => {
        commit('ADMINCREATEREGISTERBENUTZERKONTAKTFAILURE', err)
      })
  },
  adminBenutzerGeraetAnlegen({ commit }, data) {
    commit('ADMINCREATEBENUTZERGERAETREQUEST')

    return DataService.adminCreateUserGeraet(data.userId, data.geraet)
      .then(res => {
        commit('ADMINCREATEBENUTZERGERAETSUCCESS', {userId: data.userId, geraet: res.data})
      })
      .catch(err => {
        commit('ADMINCREATEBENUTZERGERAETFAILURE', err.response.data)
      })
  },
  adminRegisterBenutzerNeuesGeraet({ commit }, data) {
    commit('ADMINCREATEREGISTERBENUTZERGERAETREQUEST')

    return DataService.adminCreateUserGeraet(data.userId, data.geraet)
      .then(res => {
        commit('ADMINCREATEREGISTERBENUTZERGERAETSUCCESS', {userId: data.userId, geraet: res.data})
      })
      .catch(err => {
        commit('ADMINCREATEREGISTERBENUTZERGERAETFAILURE', err)
      })
  },


  // PUT
  adminUpdateBenutzer({ commit }, benutzer) {
    commit('ADMINUPDATEBENUTZERREQUEST')

    return DataService.adminUpdateUser(benutzer)
      .then(res => {
        commit('ADMINUPDATEBENUTZERSUCCESS', res.data)
      })
      .catch(err => {
        commit('ADMINUPDATEBENUTZERFAILURE', err)
      })
  },
  adminUpdateBenutzerKontakt({ commit }, data) {
    commit('ADMINUPDATEBENUTZERKONTAKTREQUEST')

    data.kontakt.favorit = data.kontakt.favorit == "1" ? 1 : 0

    return DataService.adminUpdateUserKontakt(data.userId, data.kontakt)
      .then(() => {
        commit('ADMINUPDATEBENUTZERKONTAKTSUCCESS')
      })
      .catch(err => {
        commit('ADMINUPDATEBENUTZERKONTAKTFAILURE', err)
      })
  },
  adminUpdateBenutzerGeraet({ commit }, data) {
    commit('ADMINUPDATEBENUTZERGERAETREQUEST')

    return DataService.adminUpdateUserGeraet(data.userId, data.geraet)
      .then(() => {
        commit('ADMINUPDATEBENUTZERGERAETSUCCESS')
      })
      .catch(err => {
        commit('ADMINUPDATEBENUTZERGERAETFAILURE', err)
      })
  },
  adminSmsProvider({ commit }, smsProvider) {
    commit('SETSMSPROVIDERREQUEST')

    let userId = smsProvider.userId
    delete smsProvider.userId

    return DataService.adminSetBenutzerSmsProvider(userId, smsProvider)
      .then(() => commit('SETSMSPROVIDERSUCCESS'))
      .catch(err => commit('SETSMSPROVIDERFAILURE', err))
  },
  adminChangeFunctions({ commit }, funktionen) {
    commit('ADMINCHANGEFUNKTIONENREQUEST')
    const benutzerId = funktionen.benutzerId
    delete funktionen.benutzerId

    return DataService.updateFunctions(funktionen)
      .then(res => {
        res.data.benutzerId = benutzerId
        commit('ADMINCHANGEFUNKTIONENSUCCESS', res.data)
      })
      .catch(err => {
        commit('ADMINCHANGEFUNKTIONENFAILURE', err)
      })
  },
  adminChangePasswort({ commit }, passwort) {
    commit('ADMINCHANGEPASSWORTREQUEST')
    const userId = passwort.userId;
    delete passwort.userId;

    return DataService.adminUpdateUserPasswort(userId, passwort)
      .then(() => {
        commit('ADMINCHANGEPASSWORTSUCCESS')
      })
      .catch(err => {
        commit('ADMINCHANGEPASSWORTFAILURE', err)
      })
  },

  // DELETE
  adminDeleteBenutzer({ commit }, benutzerId) {
    commit('ADMINDELETEBENUTZERREQUEST')

    return DataService.adminDeleteUser(benutzerId)
      .then(res => {
        if (res.status === 200) {
          commit('ADMINDELETEBENUTZERSUCCESS', benutzerId)
        }
      })
      .catch(() => {
        commit('ADMINDELETEBENUTZERFAILURE', "Es ist ein Fehler unerwarteter Fehler aufgetreten. Bitte versuche es später noch ein mal.")
      })
  },
  adminDeleteBenutzerKontakt({ commit }, data) {
    commit('ADMINDELETEBENUTZERKONTAKTREQUEST')

    return DataService.adminDeleteUserKontakt(data.userId, data.kontaktId)
      .then(() => {
        commit('ADMINDELETEBENUTZERKONTAKTSUCCESS', {userId: data.userId, kontaktId: data.kontaktId})
      })
      .catch(err => {
        commit('ADMINDELETEBENUTZERKONTAKTFAILURE', err)
      })
  },
  adminDeleteBenutzerGeraet({ commit }, data) {
    commit('ADMINDELETEBENUTZERGERAETREQUEST')

    return DataService.adminDeleteUserGeraet(data.userId, data.geraetId)
      .then(() => {
        commit('ADMINDELETEBENUTZERGERAETSUCCESS', {userId: data.userId, geraetId: data.geraetId})
      })
      .catch(err => {
        commit('ADMINDELETEBENUTZERGERAETFAILURE', err)
      })
  }
};

const mutations = {
  RESETADMINBENUTZERDATA: (state) => {
    state.adminRegisterBenutzer  = null
    state.adminRegisterBenutzerGeraet = null
    state.adminRegisterBenutzerKontakte = []
  },

  // GET
  ADMINGETBENUTZERKONTAKTEREQUEST: (state) => {state.status = { getAdminBenutzerKontakte: true}},
  ADMINGETBENUTZERKONTAKTESUCCESS: (state, res) => {
    state.status = {}
    if (Benutzer.state.alleBenutzer !== null) {
      let index = Benutzer.state.alleBenutzer.findIndex(b => b.id === res.userId)
      if (index !== null) {
        Benutzer.state.alleBenutzer[index].kontakte = res.data
      }

      localStorage.setItem('alleBenutzer', JSON.stringify(Benutzer.state.alleBenutzer))
    }
  },
  ADMINGETBENUTZERKONTAKTEFAILURE: (state, err) => {state.status = { errMsg: err}},
  ADMINGETBENUTZERGERAETEREQUEST: (state) => {state.status = { getAdminBenutzerGeraete: true}}, 
  ADMINGETBENUTZERGERAETESUCCESS: (state, res) => {
    state.status = {}
    
    if (Benutzer.state.alleBenutzer !== null) {
      let index = Benutzer.state.alleBenutzer.findIndex(b => b.id === res.userId)
      if (index !== null) {
        Benutzer.state.alleBenutzer[index].geraete = res.data
      }

      localStorage.setItem('alleBenutzer', JSON.stringify(Benutzer.state.alleBenutzer))
    }
  }, 
  ADMINGETBENUTZERGERAETEFAILURE: (state, err) => {state.status = { errMsg: err}}, 


  // POST
  ADMINCREATEBENUTZERREQUEST: (state) => {state.status = { benutzerAnlegen: true}},
  ADMINCREATEBENUTZERSUCCESS: (state, res) => {
    state.status = {}
    state.adminRegisterBenutzer = res
    Benutzer.state.alleBenutzer.push(res)

    localStorage.setItem('alleBenutzer', JSON.stringify(Benutzer.state.alleBenutzer))
  },
  ADMINCREATEBENUTZERFAILURE: (state, err) => {state.status = { errMsg: err}},
  ADMINCREATEBENUTZERKONTAKTREQUEST: (state) => {state.status = { benutzerKontaktAnlegen: true}},
  ADMINCREATEBENUTZERKONTAKTSUCCESS: (state, res) => {
    state.status = {}
    
    let benutzerIndex = Benutzer.state.alleBenutzer.findIndex(el => el.id === res.userId)
    if (Benutzer.state.alleBenutzer[benutzerIndex].kontakte) {
      Benutzer.state.alleBenutzer[benutzerIndex].kontakte.push(res.kontakt)
    } else {
      Benutzer.state.alleBenutzer[benutzerIndex].kontakte = [res.kontakt]
    }

    localStorage.setItem('alleBenutzer', JSON.stringify(Benutzer.state.alleBenutzer))
  },
  ADMINCREATEBENUTZERKONTAKTFAILURE: (state, err) => {state.status = { errMsg: err}},
  ADMINCREATEREGISTERBENUTZERKONTAKTREQUEST: (state) => { state.status = {registerBenutzerKontaktAnlegen: true}},
  ADMINCREATEREGISTERBENUTZERKONTAKTSUCCESS: (state, res) => {
    state.status = {}

    if (state.adminRegisterBenutzer.kontakte && state.adminRegisterBenutzer.kontakte.length > 0) {
      state.adminRegisterBenutzer.kontakte.push(res.kontakt)
    } else {
      state.adminRegisterBenutzer.kontakte = [res.kontakt]
    }

    state.adminRegisterBenutzerKontakte.push(res.kontakt)
  },
  ADMINCREATEREGISTERBENUTZERKONTAKTFAILURE: (state, err) => {state.status = { errMsg: err}},
  ADMINCREATEBENUTZERGERAETREQUEST: (state) => {state.status = { benutzerGeraetAnlegen: true}},
  ADMINCREATEBENUTZERGERAETSUCCESS: (state, res) => {
    state.status = {}
    
    let benutzerIndex = Benutzer.state.alleBenutzer.findIndex(el => el.id === res.userId)
    if (Benutzer.state.alleBenutzer[benutzerIndex].geraete) {
      Benutzer.state.alleBenutzer[benutzerIndex].geraete.push(res.geraet)
    } else {
      Benutzer.state.alleBenutzer[benutzerIndex].geraete = [res.geraet]
    }

    localStorage.setItem('alleBenutzer', JSON.stringify(Benutzer.state.alleBenutzer))
  },
  ADMINCREATEBENUTZERGERAETFAILURE: (state, err) => {state.status = { errMsg: err}},
  ADMINCREATEREGISTERBENUTZERGERAETREQUEST: (state) => { state.status = {registerBenutzerGeraetAnlegen: true}},
  ADMINCREATEREGISTERBENUTZERGERAETSUCCESS: (state, res) => {
    state.status = {}
    state.adminRegisterBenutzer.geraete = [res.geraet]
    state.adminRegisterBenutzerGeraet = res.geraet
  },
  ADMINCREATEREGISTERBENUTZERGERAETFAILURE: (state, err) => {state.status = { errMsg: err}},


  // PUT
  ADMINUPDATEBENUTZERREQUEST: (state) => { state.status = { adminUpdatingUser: true }},
  ADMINUPDATEBENUTZERSUCCESS: (res) => {
    if (Benutzer.state.alleBenutzer !== null) {
      let index = Benutzer.state.alleBenutzer.findIndex(b => b.id === res.id)
      if (index !== null) {
        Benutzer.state.alleBenutzer[index] = res
      } else {
        Benutzer.state.alleBenutzer.push(res);
      }

      localStorage.setItem('alleBenutzer', JSON.stringify(Benutzer.state.alleBenutzer))
    }
  },
  ADMINUPDATEBENUTZERFAILURE: (state, err) => { state.status = { errMsg: err}},
  ADMINUPDATEBENUTZERKONTAKTREQUEST: (state) => {state.status = { updatingBenutzerKontakt: true}},  
  ADMINUPDATEBENUTZERKONTAKTSUCCESS: (state) => {state.status = {}},  
  ADMINUPDATEBENUTZERKONTAKTFAILURE: (state, err) => {state.status = { errMsg: err}},
  ADMINUPDATEBENUTZERGERAETREQUEST: (state) => {state.status = { updatingBenutzerGeraet: true}},  
  ADMINUPDATEBENUTZERGERAETSUCCESS: (state) => {state.status = {}},  
  ADMINUPDATEBENUTZERGERAETFAILURE: (state, err) => {state.status = { errMsg: err}},  
  ADMINSETSMSPROVIDERREQUEST: (state) => { state.status = { settingSmsProvider: true } },
  ADMINSETSMSPROVIDERSUCCESS: (state) => { state.status = {} },
  ADMINSETSMSPROVIDERFAILURE: (state, err) => { state.status = { errMsg: err } },
  ADMINCHANGEFUNKTIONENREQUEST: (state) => { state.status = { changingBenutzerFunktionen: true } },
  ADMINCHANGEFUNKTIONENSUCCESS: (state, data) => {
    state.status = {}
    let index = Benutzer.state.alleBenutzer.findIndex(b => b.id === data.benutzerId)
    if (index !== null) {
      delete data.benutzerId
      Benutzer.state.alleBenutzer[index].funktionen = data
    }
  },
  ADMINCHANGEFUNKTIONENFAILURE: (state, err) => { state.status = { errMsg: err } },
  ADMINCHANGEPASSWORTREQUEST: (state) => { state.status = { changingBenutzerPasswort: true}},
  ADMINCHANGEPASSWORTSUCCESS: (state) => { state.status = {}},
  ADMINCHANGEPASSWORTFAILURE: (state, err) => { state.status = { errMsg: err}},


  // DELETE
  ADMINDELETEBENUTZERREQUEST: (state) => { state.status = { deletingUser: true } },
  ADMINDELETEBENUTZERSUCCESS: (benutzerId) => {
    state.status = {}
    let element = Benutzer.state.alleBenutzer.findIndex(el => el.id === benutzerId)
    Benutzer.state.alleBenutzer.splice(element, 1)
    localStorage.setItem('alleBenutzer', JSON.stringify(Benutzer.state.alleBenutzer))
  },
  ADMINDELETEBENUTZERFAILURE: (state, err) => { state.status = { errMsg: err } },
  ADMINDELETEBENUTZERKONTAKTREQUEST: (state) => {state.status = { deletingBenutzerKontakt: true}},  
  ADMINDELETEBENUTZERKONTAKTSUCCESS: (state, res) => {
    state.status = {}

    let benutzerIndex = Benutzer.state.alleBenutzer.findIndex(el => el.id === res.userId)
    if (Benutzer.state.alleBenutzer[benutzerIndex].kontakte) {
      let kontaktIndex = Benutzer.state.alleBenutzer[benutzerIndex].kontakte.findIndex(el => el.id === res.kontaktId)
      Benutzer.state.alleBenutzer[benutzerIndex].kontakte.splice(kontaktIndex, 1)
      localStorage.setItem('alleBenutzer', JSON.stringify(Benutzer.state.alleBenutzer))
    }
  },  
  ADMINDELETEBENUTZERKONTAKTFAILURE: (state, err) => {state.status = { errMsg: err}},
  ADMINDELETEBENUTZERGERAETREQUEST: (state) => {state.status = { deletingBenutzerGeraet: true}},  
  ADMINDELETEBENUTZERGERAETSUCCESS: (state, res) => {
    state.status = {}

    let benutzerIndex = Benutzer.state.alleBenutzer.findIndex(el => el.id === res.userId)
    if (Benutzer.state.alleBenutzer[benutzerIndex].geraete) {
      let geraetIndex = Benutzer.state.alleBenutzer[benutzerIndex].geraete.findIndex(el => el.id === res.geraetId)
      Benutzer.state.alleBenutzer[benutzerIndex].geraete.splice(geraetIndex, 1)
      localStorage.setItem('alleBenutzer', JSON.stringify(Benutzer.state.alleBenutzer))
    }
  },  
  ADMINDELETEBENUTZERGERAETFAILURE: (state, err) => {state.status = { errMsg: err}},
};

export default {
  state,
  getters,
  actions,
  mutations
}